import {
  ShippingMailClass,
  ShippingMailClassArrayResponse,
} from '@apiContract';

import { receivedDigitalApi } from './index';

const mailClassApi = receivedDigitalApi.injectEndpoints({
  endpoints: (builder) => ({
    getMailClasses: builder.query<ShippingMailClass[], void>({
      query: () => 'ShippingMailClass',
      transformResponse: (response: ShippingMailClassArrayResponse): ShippingMailClass[] =>
        response.objectData,
    }),
  }),
});

export const { useGetMailClassesQuery } = mailClassApi;